import { IconStack } from '@tabler/icons-react'

export const PERMISSION_SETS_STAGES = {
  id: 'Stages',
  description: 'Grant access to apply and manage stages to records.',
  icon: IconStack,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'Manage stages',
        },
        {
          type: 'checkbox',
          label: 'Apply non-exclusive record stages',
        },
        {
          type: 'checkbox',
          label: 'Apply all exclusive record stages',
        },
        {
          type: 'checkbox',
          label: 'Apply only the following exclusive record stages',
        },
        {
          type: 'multiselect',
          label: 'Exclusive stages',
          withAsterisk: true,
          data: [
            { label: 'Stage 1', value: 'STAGE_1' },
            { label: 'Stage 2', value: 'STAGE_2' },
          ],
        },
      ],
    },
  ],
}
